export default [
  { value: '1', label: '全部数据权限' },
  { value: '2', label: '自定数据权限' },
  { value: '3', label: '部门数据权限' },
  { value: '4', label: '部门及以下数据权限' }
];
